<template>
  <div id="most-popular-list" class="hide" data-behavior="vue-search-app__most-popular-list">
    <p class="has-font-weight-bold">Most popular</p>
    <div class="siema-carousel six-col-carousel has-arrows">
      <div class="slides" >
        <template v-for="(item, index) in mostPopulars">
          <MostPopularResult
              :key="`popular-${index}`"
              :id="`popular-${index}`"
              :heading="item.heading"
              :image="item.image"
              :link="item.headingHref"
              :text="item.text"
              :category="item.category"
              :categoryRank="item.categoryRankSortable"
              :importance="item.importanceSortable" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "webpack-zepto";  
import MostPopularResult from "./MostPopularResult";

$(document).on('SearchAppCarouselInitComplete', () => {
  $("[data-behavior='vue-search-app__most-popular-list']").removeClass("hide");
});

let searchinterval;

export default {
  name: "MostPopular",
  components: {
    MostPopularResult
  },
  computed: {
    mostPopulars: function () {
      return this.$store.state.mostPopular;
    },
  },
  methods:{
  },
  beforeDestroy() {
    $(document).trigger('SearchAppCarouselDestroyed');
    clearInterval(searchinterval);
  },
  mounted() { 
      searchinterval = setInterval(() => {        
        const $carouselTestElement =  $("#most-popular-list .siema-carousel > div.slides > div")[0];

        // properly initialised siema carousel element should have a non-zero width, checking for that below
        if ( $carouselTestElement !== undefined && $carouselTestElement.offsetWidth > 0 ) {
            clearInterval(searchinterval);
            $(document).trigger('SearchAppCarouselCreated');
        }
      }, 750);      

  }
}
</script>